// Using this to export CaseCardComponent and CaseTableComponent
// TODO: expose those component as independent library instead of wrapping them using DynG
var DynG = {};
export default DynG;
